import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/header/Header";
import Index from "./pages/homepage/Index";
import Footer from "./components/footer/Footer";
import Products from "./pages/products/Products";
import ProductPage from "./pages/Detail-product/ProductPage";
import Cart from "./pages/cart/Cart";
import AboutUs from "./pages/about/AboutUs";
import Terms from "./pages/Terms/Terms";
import ShippingPolicy from "./pages/ShippingPolicy/ShippingPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import ReturnsRefundPolicy from "./pages/ReturnsRefundPolicy/ReturnsRefundPolicy";
import LoginPage from "./pages/LoginPage/LoginPage";
import RegisterPage from "./pages/RegisterPage/RegisterPage";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail/VerifyEmail";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Contact from "./pages/contact/Contact";
import MeasurementForm from "./pages/mesurement/MeasurementForm";
import KurtaPajamaShowcase from "./pages/Detail-product/KurtaPajamaShowcase";
import Profile from "./pages/profile/Profile";
import AdminPanel from "./pages/admin/AdminPanel";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import AdminPasswordProtection from "./components/AdminPasswordProtection/AdminPasswordProtection";
import Shawls from "./pages/shawls/Shawls";

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname === "/admin";

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, [location.pathname]);

  return (
    <>
      {!isAdminRoute && <Header />}
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/products" element={<Products />} />
        <Route path="/ProductPage" element={<ProductPage />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/Term-Conditions" element={<Terms />} />
        <Route path="/ShippingPolicy" element={<ShippingPolicy />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/ReturnsRefundPolicy" element={<ReturnsRefundPolicy />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/MeasurementForm" element={<MeasurementForm />} />
        <Route path="/customization" element={<KurtaPajamaShowcase />} />
        <Route path="/shawls" element={<Shawls />} />
        <Route path="/profile" element={<Profile />} />
        <Route 
          path="/admin" 
          element={
            <AdminPasswordProtection>
              <AdminPanel />
            </AdminPasswordProtection>
          } 
        />
        <Route 
          path="/contact" 
          element={
            <ProtectedRoute>
              <Contact />
            </ProtectedRoute>
          } 
        />
      </Routes>
      {!isAdminRoute && <Footer />}
    </>
  );
}

function App() {
  return (
    <>
      <ToastContainer />
      <Router>
        <AppContent />
      </Router>
    </>
  );
}

export default App;
